import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import Table from "./Components/Table";
import { useDispatch, useSelector } from "react-redux";
import { reportCardDownload, searchStudent, studentReportList } from "../../redux/actions/report";
import Filters from "../Home/Components/Filters";
import { setFilters } from "../../redux/actions/dashboard";
import { REPORT_FILTER } from "../../redux/actions/types";
import { reportCardActiveFilter } from "../../helper/general";
import "./responsive.css"
const ReportCard = () => {

  const dispatch = useDispatch();

  const reportFilter = useSelector(state => state.report.reportFilter);
  const studentList = useSelector(state => state.report.studentList);
  const searchStudents = useSelector(state => state.report.searchStudentList);

  const [reload, setReload] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const additionalFilter = { "Student Name": { ...searchStudents?.data } }

  useEffect(() => {
    dispatch(studentReportList({ ...reportFilter, pageNo: (activePage - 1), pageSize }));
  }, [reload])

  const handlePageSize = e => {
    const { value } = e.target;
    setActivePage(1);
    setPageSize(value);
    dispatch(studentReportList({ ...reportFilter, pageNo: 0, pageSize: value }));
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target
    const data = { ...reportFilter }
    const index = data[name]?.indexOf(parseInt(value));
    if (index >= 0) {
      data[name].splice(index, 1)
    } else {
      data[name].push(parseInt(value));
    }
    dispatch(setFilters(REPORT_FILTER, data));
    setActivePage(1);
    setReload(Math.random());
  }

  const handlePageChange = (pageNumber) => {
    const page = pageNumber - 1;
    setActivePage(pageNumber);
    dispatch(studentReportList({ ...reportFilter, pageNo: page, pageSize }));
  }

  const handleStudentSearch = e => {
    const { name, value } = e.target;
    if (reportFilter?.kidIds?.length) {
      dispatch(setFilters(REPORT_FILTER, { ...reportFilter, kidIds: [] }));
      const currentFilter = { ...reportFilter, kidIds: [] }
      dispatch(studentReportList({ ...currentFilter, pageNo: 0, pageSize }));
    }
    if (value.length > 2) {
      dispatch(searchStudent({ ...reportFilter, nameLike: value, pageNo: 0, pageSize: 100 }));
    }
  }

  const handleReportDownload = () => {
    dispatch(reportCardDownload({ ...reportFilter, pageNo: (activePage - 1), pageSize }))
  }

  return (
    <Layout title="Report Card" page="reportCard">
      <div className="sub-header">
        <div className="page-title"><h2>Report Card</h2></div>
        <div className="top-right-btn">
          <button className="m-0 btn-bl btn-blue" onClick={handleReportDownload} type="button" aria-expanded="false">
            Download Report Card
          </button>
        </div>
      </div>
      <div className="container-fluid report-table">
        <Filters handleFilterChange={handleFilterChange} filterData={reportFilter} activeFilter={reportCardActiveFilter} additionalFilter={additionalFilter} additionMethod={handleStudentSearch} />
        <div className="text-end mb-2">
          <label className="col-md-2 mx-2">Page size</label>
          <select class="form-control" name="pageSize" className="col-md-1" onChange={handlePageSize}>
            <option value={10}>10</option>
            <option value={50}>50</option>
          </select>
        </div>
        <Table List={studentList} activePage={activePage} handlePageChange={handlePageChange} setReload={setReload} />
      </div>
    </Layout>
  );
};

export default ReportCard;
